/* eslint-disable import/no-extraneous-dependencies */
export { registerServerReference } from 'react-server-dom-webpack/server.edge'
